import React from 'react';
export default props => <p>{props.text}</p>;
